export const BadgeVariant = {
  'blue': 'blue',
  'default': 'default',
  'green': 'green',
  'light-blue': 'light-blue',
  'lilac': 'lilac',
  'orange': 'orange',
  'pink': 'pink',
  'purple': 'purple',
  'red': 'red',
  'yellow': 'yellow',
} as const
